import { SocialLoginRequest } from 'api';
import { AUTH_MICROSOFT_CLIENT_ID } from './config';

export const { GOOGLE, MICROSOFT } = SocialLoginRequest.provider;

export const AUTH_SOCIAL_DIVIDER_LABEL = 'Or';
export const AUTH_SOCIAL_GOOGLE_LABEL = 'Sign in with Google';
export const AUTH_SOCIAL_MICROSOFT_LABEL = 'Sign in with Microsoft';
export const AUTH_SOCIAL_ERROR = 'Unable to complete social sign-in right now. Please try again.';

export const AUTH_MSAL_CONFIG = {
  auth: {
    clientId: AUTH_MICROSOFT_CLIENT_ID,
  },
};
